module.exports = __webpack_public_path__ + "assets/img/phones.c16c7b59.png";